// Turkish: the source language. Every key here must exist in every other
// language file.

export const tr = {
  'common.close': 'Kapat',
  'common.cancel': 'Vazgeç',
  'common.retry': 'Yeniden dene',
  'common.topics': '{n} konu',

  'topic.central': 'Merkez konu',
  'topic.main': 'Ana konu',
  'topic.sub': 'Alt konu',
  'topic.default': 'Konu',
  'topic.floating': 'Serbest konu',

  'layout.mindmap': 'Zihin haritası',
  'layout.logic': 'Mantık şeması',
  'layout.org': 'Organizasyon şeması',
  'layoutShort.mindmap': 'Zihin',
  'layoutShort.logic': 'Mantık',
  'layoutShort.org': 'Org',

  'shape.rounded': 'Yuvarlak dikdörtgen',
  'shape.pill': 'Hap',
  'shape.rect': 'Dikdörtgen',
  'shape.underline': 'Alt çizgi',
  'shape.none': 'Şekilsiz',

  'branch.curve': 'Eğri',
  'branch.elbow': 'Dirsek',
  'branch.straight': 'Düz',

  'theme.fresh': 'Taze',
  'theme.night': 'Gece',
  'theme.paper': 'Kâğıt',
  'theme.mono': 'Sade',

  'marker.priority-1': 'Öncelik 1',
  'marker.priority-2': 'Öncelik 2',
  'marker.priority-3': 'Öncelik 3',
  'marker.priority-4': 'Öncelik 4',
  'marker.priority-5': 'Öncelik 5',
  'marker.task-0': 'Başlanmadı',
  'marker.task-25': '%25',
  'marker.task-50': '%50',
  'marker.task-75': '%75',
  'marker.task-100': 'Tamamlandı',
  'marker.flag-red': 'Kırmızı bayrak',
  'marker.flag-blue': 'Mavi bayrak',
  'marker.flag-green': 'Yeşil bayrak',
  'marker.symbol-star': 'Yıldız',
  'marker.symbol-question': 'Soru',
  'marker.symbol-idea': 'Fikir',

  'cmd.palette': 'Komut paleti',
  'cmd.shortcuts': 'Klavye kısayolları',
  'cmd.language': 'Arayüz dili',
  'cmd.back': 'Haritalara dön',
  'cmd.addChild': 'Alt konu ekle',
  'cmd.addSibling': 'Kardeş konu ekle',
  'cmd.addSiblingBefore': 'Öncesine kardeş konu ekle',
  'cmd.edit': 'Metni düzenle',
  'cmd.remove': 'Sil',
  'cmd.undo': 'Geri al',
  'cmd.redo': 'Yinele',
  'cmd.copy': 'Kopyala',
  'cmd.cut': 'Kes',
  'cmd.paste': 'Yapıştır',
  'cmd.collapse': 'Daralt / genişlet',
  'cmd.moveUp': 'Konuyu yukarı taşı',
  'cmd.moveDown': 'Konuyu aşağı taşı',
  'cmd.indent': 'İçeri al (üstteki konunun altına)',
  'cmd.outdent': 'Dışarı al (bir üst seviyeye)',
  'cmd.navLeft': 'Sola git',
  'cmd.navRight': 'Sağa git',
  'cmd.navUp': 'Yukarı git',
  'cmd.navDown': 'Aşağı git',
  'cmd.relation': 'İlişki oku ekle',
  'cmd.floating': 'Serbest konu ekle',
  'cmd.note': 'Not ekle',
  'cmd.save': 'Dosyaya kaydet',
  'cmd.saveAs': 'Farklı kaydet',
  'cmd.toggleOutline': 'Harita / ana hat görünümü',
  'cmd.zoomIn': 'Yakınlaştır',
  'cmd.zoomOut': 'Uzaklaştır',
  'cmd.fit': 'Haritayı sığdır',
  'cmd.centerSelected': 'Seçili konuyu ortala',
  'cmd.history': 'Sürüm geçmişi',
  'cmd.panel': 'Biçim paneli',

  'key.space': 'Boşluk',

  'editor.back': 'Haritalara dön',
  'editor.insert': 'Ekle',
  'editor.stats': '{n} konu · {layout}',
  'canvas.label': 'Zihin haritası: {title}',
  'edit.topicText': 'Konu metni',

  'tb.topic': 'Konu',
  'tb.subtopic': 'Alt konu',
  'tb.relation': 'İlişki',
  'tb.relationTip': 'İlişki oku: başka bir konuya bağla',
  'tb.floating': 'Serbest konu',
  'tb.floatingTip': 'Serbest konu (boş alana çift tıkla)',
  'tb.marker': 'İşaret',
  'tb.markerTip': 'İşaret ekle',
  'tb.note': 'Not',
  'tb.noteTip': 'Not ekle',
  'tb.image': 'Görsel',
  'tb.imageTip': 'Konuya görsel ekle',
  'tb.removeImage': 'Görseli kaldır',
  'tb.removeImageTip': 'Konudaki görseli kaldır',
  'tb.collapse': 'Daralt',
  'tb.delete': 'Sil',

  'view.label': 'Görünüm',
  'view.map': 'Harita',
  'view.outline': 'Ana hat',

  'file.save': 'Kaydet',
  'file.saveToComputer': 'Bilgisayara kaydet',
  'file.saveTip': 'Haritayı dosya olarak kaydet',
  'file.saveToTip': '{name} dosyasına kaydet',
  'file.savedHere': 'Bu cihaza kaydedildi',
  'file.savedTo': 'Kaydedildi · {name}',
  'file.saving': 'Kaydediliyor…',
  'file.permission': '{name} dosyasına yazmak için izin ver',
  'file.permissionTip': 'Tarayıcı, dosyaya yazmak için yeniden izin istiyor',
  'file.writeFailed': '{name} dosyasına yazılamadı, yeniden dene',

  'export.menu': 'Dışa aktar',
  'export.saveAs': 'Farklı kaydet…',
  'export.unlink': 'Dosya bağlantısını kaldır',
  'export.png': 'PNG görsel',
  'export.svg': 'SVG vektör',
  'export.opml': 'OPML (ana hat)',
  'export.keizu': 'Keizu dosyası (.keizu)',
  'export.json': 'Düz JSON (git dostu)',

  'toast.storageFull': 'Kaydedilemedi: tarayıcı deposu dolu olabilir.',
  'toast.savedTo': '{name} dosyasına kaydedildi',
  'toast.linked': '{name} dosyasına kaydedildi. Değişiklikler bu dosyaya otomatik yazılacak.',
  'toast.downloaded': 'Dosya indirildi',
  'toast.saveFailed': 'Kaydedilemedi',
  'toast.unlinked': 'Dosya bağlantısı kaldırıldı; harita bu cihazda kalmaya devam ediyor',
  'toast.imageFailed': 'Görsel eklenemedi',
  'toast.cut': 'Konu kesildi',
  'toast.copied': 'Konu kopyalandı',
  'toast.pickRelation': 'İlişkinin gideceği konuya tıkla (iptal: Esc)',
  'toast.exportFailed': 'Dışa aktarma başarısız oldu',
  'toast.restored': 'Sürüm geri yüklendi (geri almak için {key})',

  'panel.label': 'Biçim',
  'panel.topic': 'Konu',
  'panel.map': 'Harita',
  'panel.pickTopic': 'Biçimlendirmek için bir konu seç.',
  'panel.shape': 'Şekil',
  'panel.fill': 'Dolgu',
  'panel.auto': 'Otomatik',
  'panel.autoFill': 'Otomatik dolgu',
  'panel.fillColor': 'Dolgu {color}',
  'panel.text': 'Metin',
  'panel.fontSize': 'Yazı boyutu',
  'panel.autoSize': 'Otomatik boyut',
  'panel.bold': 'Kalın',
  'panel.italic': 'İtalik',
  'panel.branchLayout': 'Dal yerleşimi',
  'panel.inherit': 'Aynı',
  'panel.branchInherit': 'Üst daldaki gibi ({layout})',
  'panel.branchHint': 'Bu konunun alt dalları seçilen şemayla dizilir; haritanın geri kalanı değişmez.',
  'panel.markers': 'İşaretler',
  'panel.note': 'Not',
  'panel.notePlaceholderRoot': 'Haritayla ilgili not…',
  'panel.notePlaceholder': 'Bu konuya not ekle…',
  'panel.theme': 'Tema',
  'panel.layout': 'Yerleşim',
  'panel.branches': 'Dallar',
  'panel.multicolor': 'Çok renkli dallar',
  'panel.relation': 'İlişki',
  'panel.label2': 'Etiket',
  'panel.relationPlaceholder': 'örn. besler, bağlı',
  'panel.deleteRelation': 'İlişkiyi sil',

  'outline.label': 'Ana hat: {title}',
  'outline.expand': 'Genişlet',
  'outline.collapse': 'Daralt',
  'note.untitled': 'Adsız konu',
  'note.dialog': '{topic} notu',
  'note.close': 'Notu kapat',
  'note.closeTip': 'Kapat (Esc)',
  'note.empty': 'Bu konuda not yok.',
  'note.showInTopic': 'Konunun içinde göster',
  'note.clear': 'Notu sil',
  'note.presentLabel': 'Not',
  'outline.hasNote': 'Notu var',

  'palette.title': 'Komut paleti',
  'palette.placeholder': 'Komut veya konu ara…',
  'palette.commands': 'Komutlar',
  'palette.topics': 'Bu haritadaki konular',
  'palette.empty': 'Eşleşen komut veya konu yok.',
  'palette.inNote': 'notta',
  'palette.hint': '↑↓ seç · Enter çalıştır · Esc kapat',

  'keys.title': 'Klavye kısayolları',
  'keys.intro': 'Bir kısayolu değiştirmek için "Ekle"ye bas ve yeni tuşa bas. Değişiklikler bu cihazda saklanır.',
  'keys.add': 'Ekle',
  'keys.press': 'Tuşa bas… (iptal: Esc)',
  'keys.remove': '{key} kısayolunu kaldır',
  'keys.reset': 'Varsayılan',
  'keys.resetAll': 'Tümünü varsayılana döndür',
  'keys.moved': '{key} artık "{to}" için; "{from}" komutundan kaldırıldı.',
  'keys.outlineOnly': 'ana hatta',
  'keys.group.general': 'Genel',
  'keys.group.edit': 'Düzenleme',
  'keys.group.navigate': 'Gezinme',
  'keys.group.view': 'Görünüm',
  'keys.group.file': 'Dosya',
  'keys.group.fixed': 'Sabit',
  'keys.fixed.newline': 'Düzenlerken yeni satır',
  'keys.fixed.type': 'Yazmaya başla: metni düzenle',
  'keys.fixed.escape': 'Seçimi veya ilişki eklemeyi iptal et',
  'keys.fixed.dragKey': 'Sürükle',
  'keys.fixed.drag': 'Konuyu başka bir konunun altına taşı, boş alana bırakınca serbest konu yap',
  'keys.fixed.dblKey': 'Çift tıkla',
  'keys.fixed.dbl': 'Boş alana: serbest konu, konuya: düzenle',
  'keys.fixed.wheel': 'tekerlek',
  'keys.fixed.zoom': 'Yakınlaştır / uzaklaştır',

  'versions.title': 'Sürüm geçmişi',
  'versions.intro': 'Keizu bu cihazda haritanın eski hallerini kendiliğinden saklar: açarken, kapatırken ve düzenlerken en çok beş dakikada bir. Eski sürümler zamanla seyreltilir.',
  'versions.restore': 'Bu sürümü geri yükle',
  'versions.empty': 'Henüz kayıtlı sürüm yok. Düzenledikçe burada birikir.',
  'versions.today': 'Bugün {time}',
  'versions.preview': '{title} önizlemesi',
  'versions.reason.open': 'Açılırken',
  'versions.reason.close': 'Kapatılırken',
  'versions.reason.auto': 'Otomatik',
  'versions.reason.restore': 'Geri yüklemeden önce',

  'time.justNow': 'az önce',
  'time.minutesAgo': '{n} dk önce',
  'time.today': 'bugün {time}',

  'home.newMap': 'Yeni harita',
  'home.openFile': 'Dosya aç',
  'home.openFileTip': '.keizu, .json, .xmind, .opml veya Markdown',
  'home.openHint': '.keizu, .xmind, OPML ve Markdown açılır. Dosyayı pencereye sürükleyip bırakabilirsin.',
  'home.onDevice': 'Bu cihazda',
  'home.onDeviceDesktop': 'Haritaların bu bilgisayarda saklanır. Bir haritayı "Kaydet" ile dosya olarak tuttuğunda değişiklikler o dosyaya da yazılır.',
  'home.onDeviceWeb': 'Haritaların bu tarayıcıda saklanır, hesap veya sunucu gerekmez. Yedek ya da başka cihaz için "Bilgisayara kaydet" ile dosya olarak al.',
  'home.versionsNote': 'Her haritanın son sürümleri otomatik olarak saklanır (sürüm geçmişi).',
  'home.language': 'Dil',
  'home.search': 'Haritalarda ara',
  'home.searchPlaceholder': 'Tüm haritalarda ara (başlık, konu, not)',
  'home.inTopics': 'Konularda bulunanlar',
  'home.noTopicHits': 'Hiçbir haritanın konularında geçmiyor.',
  'home.hitCount': '{n} eşleşme',
  'home.start': 'Yeni başla',
  'home.myMaps': 'Haritalarım',
  'home.titleMatches': 'Başlığı eşleşen haritalar',
  'home.noTitleMatch': 'Başlığı eşleşen harita yok.',
  'home.empty': 'Henüz harita yok. Yukarıdan bir tane oluştur ya da bir dosya aç.',
  'home.fileTip': 'Bu dosyaya da kaydediliyor',
  'home.deleteMap': '{title} haritasını sil',
  'home.confirmDelete': '"{title}" silinsin mi? Bu işlem geri alınamaz.',
  'home.openFailed': 'Dosya açılamadı.',
  'home.imported': '{n} harita içe aktarıldı.',
  'home.someUnreadable': 'Bazı dosyalar okunamadı.',
  'home.dropHint': 'Açmak için bırak',

  'versions.reason.sync': 'Senkrondan önce',

  'home.sync': 'Bulut senkronu',
  'home.syncOff': 'İstersen kendi sunucunu bağlayıp haritalarını cihazların arasında eşitleyebilirsin.',

  'settings.title': 'Ayarlar',
  'settings.back': 'Haritalara dön',

  'sync.title': 'Bulut senkronu',
  'sync.intro': 'Haritaların her zaman önce bu cihaza kaydedilir. Bir sunucu bağladığında arka planda eşitlenir; internet yokken çalışmaya devam edersin.',
  'sync.connectTitle': 'Sunucuna bağlan',
  'sync.notConnected': 'Henüz bağlı değil',
  'sync.tab.address': 'Adres ile',
  'sync.tab.code': 'Eşleştirme kodu',
  'sync.tab.webdav': 'WebDAV',
  'sync.server': 'Sunucu adresi',
  'sync.serverPlaceholder': 'keizu.alanadin.com',
  'sync.find': 'Bul',
  'sync.finding': 'Aranıyor…',
  'sync.found': '{name} {version} bulundu',
  'sync.foundDetail': '{secure} · API v{api} · hesabınla gir',
  'sync.https': 'HTTPS geçerli',
  'sync.noHttps': 'HTTPS yok: bağlantı şifrelenmiyor',
  'sync.username': 'Kullanıcı adı',
  'sync.password': 'Şifre',
  'sync.code': '6 haneli kod',
  'sync.codeHint': 'Sunucu panelinde "Kod üret"e bas veya bağlı başka bir cihazda "Başka cihaz bağla"yı kullan.',
  'sync.connect': 'Bağlan',
  'sync.connecting': 'Bağlanıyor…',
  'sync.tokenNote': 'Şifre saklanmaz; yalnız bu cihaza özel bir token alınır.',
  'sync.webdavUrl': 'WebDAV klasör adresi',
  'sync.webdavPlaceholder': 'https://bulut.alanadin.com/remote.php/dav/files/kullanici/Keizu',
  'sync.webdavNote': 'Nextcloud, ownCloud ve diğer WebDAV sunucuları. Hesap şifren yerine bir uygulama şifresi kullan; bu cihazda saklanır. Tarayıcıda çalışması için sunucunun CORS izni vermesi gerekir; masaüstü uygulamasında gerekmez.',
  'sync.connectedTo': 'Bağlı: {server}',
  'sync.signedInAs': '{user} olarak',
  'sync.webdavAs': 'WebDAV · {user}',
  'sync.state.off': 'Bağlı değil',
  'sync.state.idle': 'Eşitlendi',
  'sync.state.syncing': 'Eşitleniyor…',
  'sync.state.error': 'Bazı haritalar eşitlenemedi',
  'sync.state.offline': 'Sunucuya ulaşılamıyor; değişiklikler bu cihazda bekliyor',
  'sync.state.signedOut': 'Oturum kapandı; yeniden bağlan',
  'sync.lastSync': 'Son eşitleme: {when}',
  'sync.never': 'henüz yok',
  'sync.syncNow': 'Şimdi eşitle',
  'sync.disconnect': 'Bağlantıyı kes',
  'sync.reconnect': 'Yeniden bağlan',
  'sync.confirmDisconnect': 'Bu cihazın sunucu bağlantısı kesilsin mi? Haritaların bu cihazda kalır.',
  'sync.updateServer': 'Sunucu bu uygulamadan eski (sunucu {version}). Sunucuyu güncelle: sunucuda "keizu-server update".',
  'sync.updateApp': 'Bu sunucu Keizu uygulamasının daha yeni bir sürümünü istiyor. Uygulamayı güncelle.',
  'sync.pairTitle': 'Başka cihaz bağla',
  'sync.pairIntro': 'Telefonda QR\'ı okut veya başka bir bilgisayarda bu kodu gir.',
  'sync.pairMake': 'Kod üret',
  'sync.pairExpires': '{time} içinde geçersiz olur',
  'sync.pairExpired': 'Süresi doldu; yeni kod üret.',
  'sync.pairQr': 'Eşleştirme QR kodu',
  'sync.noServerTitle': 'Sunucun yok mu?',
  'sync.noServerText': 'Hetzner veya herhangi bir Linux sunucuya tek komutla kur. Alan adı ve HTTPS otomatik ayarlanır; sunucunda zaten nginx varsa onun arkasında da çalışır.',
  'sync.guide': 'Kurulum rehberini aç',
  'sync.copy': 'Kopyala',
  'sync.copied': 'Kopyalandı',
  'sync.auto': 'Otomatik senkron',
  'sync.autoHint': 'Her değişiklikten birkaç saniye sonra ve dakikada bir eşitler',
  'sync.policy': 'Çakışma olursa',
  'sync.policyHint': 'İki cihaz aynı haritayı çevrimdışıyken düzenlediğinde',
  'sync.policy.merge': 'Konu bazlı birleştir, olmazsa kopya oluştur',
  'sync.policy.copy': 'Her zaman kopya oluştur',
  'sync.policy.server': 'Sunucudakini koru',
  'sync.activity': 'Son etkinlik',
  'sync.activityEmpty': 'Henüz bir şey eşitlenmedi.',
  'sync.col.time': 'Zaman',
  'sync.col.map': 'Harita',
  'sync.col.action': 'İşlem',
  'sync.action.pushed': 'Gönderildi',
  'sync.action.pulled': 'Alındı',
  'sync.action.merged': 'Çakışma · birleştirildi',
  'sync.action.copied': 'Çakışma · kopya oluşturuldu',
  'sync.action.keptRemote': 'Çakışma · sunucudaki tutuldu',
  'sync.action.removedRemote': 'Sunucudan silindi',
  'sync.action.removedLocal': 'Bu cihazdan silindi (başka cihazda silinmiş)',
  'sync.action.error': 'Hata',
  'sync.copyTitle': '{title} (çakışan kopya)',
  'sync.device.desktop': 'masaüstü',
  'sync.linkTitle': 'Bağlantı linki açıldı',
  'sync.linkText': '{server} sunucusuna bağlanmak için kodu onayla.',

  'layout.concept': "Kavram haritası",
  'layout.timeline': "Zaman çizelgesi",
  'layout.fishbone': "Balık kılçığı",
  'layout.matrix': "Matris",
  'layoutShort.concept': "Kavram",
  'layoutShort.timeline': "Zaman",
  'layoutShort.fishbone': "Kılçık",
  'layoutShort.matrix': "Matris",
  'tpl.concept': "Kavram",
  'tpl.conceptLink': "içerir",
  'tpl.timeline': "Zaman çizelgesi",
  'tpl.event': "Olay",
  'tpl.detail': "Ayrıntı",
  'tpl.fishbone': "Sorun",
  'tpl.cause': "Neden",
  'tpl.subcause': "Alt neden",
  'tpl.matrix': "Matris",
  'tpl.column': "Sütun",
  'tpl.cell': "Hücre",
  'panel.link': "Bağlantı",
  'panel.linkLabel': "Üst konuya giden çizgideki yazı",
  'panel.linkLabelPlaceholder': "ör. neden olur, içerir",
  'panel.linkMap': "Başka bir haritaya bağla",
  'panel.linkNone': "Bağlantı yok",
  'panel.linkMissing': "(Bu cihazda olmayan harita)",
  'panel.linkUrl': "veya bir web adresine",
  'panel.linkHint': "Konudaki bağlantı simgesine tıkla ya da Alt+Enter ile aç.",
  'toast.linkMissing': "Bağlı harita bu cihazda yok.",
  'toast.linkFailed': "Bağlantı açılamadı.",
  'cmd.present': "Sunum modu",
  'cmd.openLink': "Konudaki bağlantıyı aç",
  'cmd.share': "Paylaş",
  'present.label': "Sunum",
  'present.prev': "Önceki",
  'present.next': "Sonraki",
  'present.exit': "Sunumdan çık (Esc)",
  'present.step': "{n} / {total}",

  'e2e.title': "Uçtan uca şifreleme",
  'e2e.on': "Açık",
  'e2e.off': "Kapalı",
  'e2e.intro': "Açıkken haritalar bu cihazdan çıkmadan önce senin parolanla şifrelenir. Sunucu (veya WebDAV klasörü) onları saklar ama içini okuyamaz.",
  'e2e.noShare': "Şifreli haritalar başkalarıyla paylaşılamaz ve canlı düzenlenemez, çünkü sunucu neyin değiştiğini göremez. Sana paylaşılan haritalar bundan etkilenmez.",
  'e2e.samePass': "Senkron yapan her cihazda aynı parolayı gir.",
  'e2e.lost': "Parolayı unutursan sunucudaki şifreli kopyalar açılamaz; bu cihazdaki haritaların yine durur.",
  'e2e.setup': "Şifrelemeyi aç…",
  'e2e.pass': "Parola (en az 8 karakter)",
  'e2e.pass2': "Parolayı tekrar yaz",
  'e2e.mismatch': "İki parola aynı değil.",
  'e2e.tooShort': "Parola en az 8 karakter olmalı.",
  'e2e.enable': "Şifrele ve senkronla",
  'e2e.disable': "Şifrelemeyi kapat",
  'e2e.confirmOff': "Şifreleme kapatılsın mı? Haritalar bir sonraki senkronda sunucuya okunabilir olarak gönderilir.",
  'home.sharedWithMe': "Benimle paylaşılanlar",
  'home.sharedEdit': "{owner} · düzenleyebilirsin",
  'home.sharedView': "{owner} · görüntüleyebilirsin",
  'home.sharedGone': "Bu harita artık seninle paylaşılmıyor ya da silinmiş.",
  'live.keptServer': "Bu cihazdaki değişiklikler sunucudakiyle birleştirilemedi; sunucudaki açıldı, bu cihazdaki sürüm geçmişinde.",
  'live.peers': "{n} kişi daha burada",
  'live.readOnly': "Bu haritayı yalnızca görüntüleyebilirsin.",
  'live.readOnlyBar': "Yalnızca görüntüleme",
  'live.sharedEdit': "{owner} paylaştı",
  'live.sharedView': "{owner} paylaştı · görüntüleme",
  'live.state.off': "Bağlı değil",
  'live.state.connecting': "Bağlanıyor…",
  'live.state.live': "Canlı",
  'live.state.offline': "Bağlantı koptu, yeniden deneniyor",
  'live.state.closed': "Oturum kapandı",
  'share.button': "Paylaş",
  'share.title': "Haritayı paylaş",
  'share.loading': "Yükleniyor…",
  'share.notSynced': "Bu harita henüz sunucuda değil. Paylaşmak için önce senkronlanması gerekiyor.",
  'share.syncNow': "Şimdi senkronla",
  'share.encrypted': "Uçtan uca şifreleme açık. Şifreli haritalar paylaşılamaz, çünkü sunucu içeriği göremez. Ayarlar → Bulut senkronu'ndan kapatabilirsin.",
  'share.intro': "Bu sunucudaki bir hesapla paylaş. O kişi yalnızca bu haritayı görür, diğer haritalarını değil. Aynı anda düzenleyenler birbirinin değişikliğini canlı görür.",
  'share.user': "Kullanıcı adı",
  'share.userPlaceholder': "Kullanıcı adı",
  'share.role': "Yetki",
  'share.roleFor': "{name} için yetki",
  'share.role.edit': "Düzenleyebilir",
  'share.role.view': "Görüntüleyebilir",
  'share.add': "Paylaş",
  'share.remove': "Kaldır",
  'share.nobody': "Henüz kimseyle paylaşılmadı.",
  'share.linkTitle': "Salt okunur link",
  'share.linkHint': "Hesabı olmayan biri de linkle haritayı görebilir ama değiştiremez.",
  'share.linkCreate': "Link oluştur",
  'share.linkOn': "Linki bilen herkes haritanın güncel hâlini görebilir.",
  'share.linkOff': "Linki iptal et",
  'share.liveNow': "Şu an {n} kişi bu haritada.",
  'view.readOnly': "Salt okunur",
  'view.notFound': "Bu paylaşım linki geçersiz ya da iptal edilmiş.",
  'view.madeWith': "Keizu ile paylaşıldı",
} as const;

export type MessageKey = keyof typeof tr;
